import { Column, RichTextDisplay } from "@/components";

export const RichTextDisplayArea = ({
  label,
  richText,
}: {
  label: string;
  richText: string;
}) => {
  return (
    <Column className="gap-2">
      <p className="font-semibold text-slate-800">{label}</p>
      <div className="rounded-xl border border-slate-200 bg-slate-50/50 p-5">
        <RichTextDisplay richText={richText} />
      </div>
    </Column>
  );
};
